import styled from "styled-components"
import { useSelector } from 'react-redux';
import { useState,useEffect } from 'react';
import GameCardReventa from "./gameCardReventa.jsx"
import api from '../../axios.js';
import {themeModules} from "../../theme/theme.js"

let Container=styled.div`
	width:100vw;
 	height:90.5vh;
 	overflow:auto;
 	display:flex;
 	flex-direction:column;
 	align-items:center;
 	&::-webkit-scrollbar{
		background-color:transparent;
		width:3px
	};
	&::-webkit-scrollbar-track{
		background:trasparent;		
		border-radius:25px
	};
	&::-webkit-scrollbar-thumb {
    	background: #27B0FE;
    	border-radius: 15px;
  	};
  	&::-webkit-scrollbar:horizontal{display:none}

 `;
const ContainerJuegos=styled.div`
  position:relative;
  display:flex;
  flex-wrap:wrap;
  justify-content:space-around;
  align-items:center;
  min-height:85%;
  background-color:${themeModules.panel};
  border-radius:10px;
  width:98%;
  &::-webkit-scrollbar{
		background-color:transparent;
		width:3px
	};
	&::-webkit-scrollbar-track{
		background:trasparent;		
		border-radius:25px
	};
	&::-webkit-scrollbar-thumb {
    	background: #27B0FE;
    	border-radius: 15px;
  	};
  	&::-webkit-scrollbar:horizontal{display:none}
`;

let Juegos=styled.div`
	width:100%;
	display:flex;
	height:90%;
	justify-content:space-evenly;
	align-items:center;
`;
const Logo=styled.div`
		font-size:13px;
		width:96%;
		color:white;
		z-index:1;
		height:10%;
		display:flex;
		align-items:center;
		justify-content:end;
`;




const Titulo=styled.div`
	font-size:25px;
	width:95%;
	display:flex;
	justify-content:start;
	align-items:center;
	position:sticky;
	top:0px;
	padding-left:15px;
	height:13% ;
	z-index:2;
	color:white;

`;



export default function ReventasClient(props) {
	let userActive=useSelector(state=>state.login.user);
	let [reventas,setReventas]=useState([]);
	let solicitudEstado=useSelector(state=>state.solicitud.estadoSolicitud);
	useEffect(()=>{
   
    if(solicitudEstado===0){   

      api.get(`/reventa/user?id=${userActive.id}`)
        .then(rsp=>rsp.data)
        .then(rsp=>setReventas(rsp))
        .catch(err => {
        console.error(`error reventas : ${err}`)
        });
    }
   },[userActive.id,solicitudEstado]);
	
	return(
		<Container>
			<Titulo>juegos ofrecidos para revender</Titulo>
			<ContainerJuegos>
				<Juegos>
					{reventas.map(reventa=>(reventa.publicar_reventa?<GameCardReventa reventa={reventa}/>:null) ) }
				</Juegos>
				<Logo><b>Playlan</b>mym™	</Logo>
			</ContainerJuegos>
		</Container>


		)
}